import { render, staticRenderFns } from "./TicketTab.vue?vue&type=template&id=0d86ec80&scoped=true"
import script from "./TicketTab.vue?vue&type=script&lang=js"
export * from "./TicketTab.vue?vue&type=script&lang=js"
import style0 from "./TicketTab.vue?vue&type=style&index=0&id=0d86ec80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d86ec80",
  null
  
)

export default component.exports